const ROOT = process.env.REACT_APP_AUGMENTT_API_URL

export const generateHubTaskUrl = (parameters) => {
  const { tasktype, action, root = ROOT } = parameters

  // Combine the TASK URL with the action and tasktype
  return `${root}/hub/microsoft/${tasktype}/${action}`
}
